import { priceFormatter } from './price-formatter';
import { CURRENCY } from '../../constants/app-constants';
const makePriceLabel = (price, currency = CURRENCY.AE) => `${currency} ${priceFormatter(price, true, currency)}`;
export const makePriceLabelRoundAE = (price) => {
    return makePriceLabel(Math.round(price), CURRENCY.AE);
};

export default makePriceLabel;
